// Función utilitaria para obtener información del usuario autenticado con Cognito
export function getCognitoUser() {
  try {
    const userStr = localStorage.getItem('user')
    if (!userStr) return null
    
    return JSON.parse(userStr)
  } catch (error) {
    console.error('Error obteniendo información del usuario:', error)
    return null
  }
}

// Función para decodificar JWT y extraer información
function decodeJWT(token) {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    
    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Error decodificando JWT:', error)
    return null
  }
}

// Función para obtener los permisos completos del usuario
export function getCognitoUserPermissions() {
  try {
    const accessToken = localStorage.getItem('token')
    if (!accessToken) return null
    
    const tokenData = decodeJWT(accessToken)
    if (!tokenData || !tokenData['custom:permissions']) return null
    
    const permissionsString = tokenData['custom:permissions']
    return JSON.parse(permissionsString)
  } catch (error) {
    console.error('Error obteniendo permisos del usuario:', error)
    return null
  }
}

// Función para verificar si el usuario tiene un rol específico
export function hasRole(roleId) {
  const permissions = getCognitoUserPermissions()
  if (!permissions || !permissions.roles) return false
  
  return permissions.roles.some(role => role.id === roleId || role.id === parseInt(roleId))
}

// Función para obtener el rol del usuario desde el access token
export function getCognitoUserRole() {
  try {
    const accessToken = localStorage.getItem('token')
    if (!accessToken) {
      console.log('No hay access token disponible')
      return null
    }
    
    const tokenData = decodeJWT(accessToken)
    if (!tokenData) {
      console.log('No se pudo decodificar el access token')
      return null
    }
    
    // console.log('Datos completos del access token:', tokenData)
    
    // Extraer el rol desde custom:permissions
    if (tokenData['custom:permissions']) {
      try {
        const permissionsString = tokenData['custom:permissions']
        const permissions = JSON.parse(permissionsString)
        if (permissions.roles && permissions.roles.length > 0) {
          // Obtener el ID del primer rol (o podrías buscar uno específico)
          const roleId = permissions.roles[0].id
          return roleId
        }
      } catch (parseError) {
        console.error('Error parseando custom:permissions:', parseError)
      }
    }
    
    // Fallback a otros campos por si acaso
    const role = tokenData.role || 
                 tokenData['custom:role'] || 
                 tokenData['custom:user_role'] ||
                 tokenData['cognito:groups']?.[0] || 
                 tokenData.groups?.[0] ||
                 null
                 
  // Return fallback role value if present
    return role
  } catch (error) {
    console.error('Error obteniendo rol del usuario:', error)
    return null
  }
}

// Función para obtener el token de acceso de Cognito
export function getCognitoAccessToken() {
  return localStorage.getItem('token')
}

// Función para obtener el ID token de Cognito
export function getCognitoIdToken() {
  return localStorage.getItem('id_token')
}

// Función para verificar si el usuario está autenticado
export function isAuthenticated() {
  const token = localStorage.getItem('token')
  const expiresAt = localStorage.getItem('expires_at')
  const user = localStorage.getItem('user')
  
  if (!token || !expiresAt || !user) {
    return false
  }
  
  const now = Date.now()
  const expiration = parseInt(expiresAt)
  
  return expiration > now
}

// Función para cerrar sesión
export function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('id_token')
  localStorage.removeItem('token_type')
  localStorage.removeItem('expires_at')
  localStorage.removeItem('user')
}